import { render, staticRenderFns } from "./QuoteDisplay.vue?vue&type=template&id=6dff1a46&"
import script from "./QuoteDisplay.vue?vue&type=script&lang=js&"
export * from "./QuoteDisplay.vue?vue&type=script&lang=js&"
import style0 from "./QuoteDisplay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports